var _mask, _path, _path2, _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnClickerCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 278,
    viewBox: "0 0 278 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3982_6189",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139 278C215.768 278 278 215.768 278 139C278 62.2324 215.768 0 139 0C62.2324 0 0 62.2324 0 139C0 215.768 62.2324 278 139 278ZM139 263C207.483 263 263 207.483 263 139C263 70.5167 207.483 15 139 15C70.5167 15 15 70.5167 15 139C15 207.483 70.5167 263 139 263Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139 278C215.768 278 278 215.768 278 139C278 62.2324 215.768 0 139 0C62.2324 0 0 62.2324 0 139C0 215.768 62.2324 278 139 278ZM139 263C207.483 263 263 207.483 263 139C263 70.5167 207.483 15 139 15C70.5167 15 15 70.5167 15 139C15 207.483 70.5167 263 139 263Z",
    fill: "url(#paint0_linear_3982_6189)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M277 139C277 215.215 215.215 277 139 277V279C216.32 279 279 216.32 279 139H277ZM139 1C215.215 1 277 62.7847 277 139H279C279 61.6801 216.32 -1 139 -1V1ZM1 139C1 62.7847 62.7847 1 139 1V-1C61.6801 -1 -1 61.6801 -1 139H1ZM139 277C62.7847 277 1 215.215 1 139H-1C-1 216.32 61.6801 279 139 279V277ZM262 139C262 206.931 206.931 262 139 262V264C208.036 264 264 208.036 264 139H262ZM139 16C206.931 16 262 71.069 262 139H264C264 69.9644 208.036 14 139 14V16ZM16 139C16 71.069 71.069 16 139 16V14C69.9644 14 14 69.9644 14 139H16ZM139 262C71.069 262 16 206.931 16 139H14C14 208.036 69.9644 264 139 264V262Z",
    fill: "url(#paint1_radial_3982_6189)",
    mask: "url(#path-1-inside-1_3982_6189)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3982_6189)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 139,
    cy: 139,
    r: 124,
    fill: "url(#paint2_linear_3982_6189)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 139,
    cy: 139,
    r: 123.5,
    stroke: "url(#paint3_radial_3982_6189)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3982_6189",
    x: 15,
    y: 15,
    width: 248,
    height: 252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3982_6189"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3982_6189",
    x1: 39,
    y1: 36.5,
    x2: 132.574,
    y2: 284.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477469,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3982_6189",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(229.238 241.008) rotate(-130.99) scale(277.709 277.709)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520877,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3982_6189",
    x1: 25.233,
    y1: 21.3879,
    x2: 142.089,
    y2: 321.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3982_6189",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(219.5 230) rotate(-130.99) scale(247.74 247.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520877,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnClickerCircle);
export default __webpack_public_path__ + "static/media/btn_clicker_circle.40b7fbfb00ca2b4cccd21b44bc218f14.svg";
export { ForwardRef as ReactComponent };